import React from "react";
import PropTypes from 'prop-types';
import "./semaphors.css";
import green from "../../img/zeleny-semafor.svg";
import yellow from "../../img/zluty-semafor.svg";
import red from "../../img/cerveny-semafor.svg";
import greenRo from "../../img/zeleny-semafor-readonly.svg";
import yellowRo from "../../img/zluty-semafor-readonly.svg";
import redRo from "../../img/cerveny-semafor-readonly.svg";

const images = {
    na: require("../../img/cribisIndex/bw-na.svg"),
    e:  require("../../img/cribisIndex/c-e.svg"),
    d2: require("../../img/cribisIndex/c-d2.svg"),
    d1: require("../../img/cribisIndex/c-d1.svg"),
    c3: require("../../img/cribisIndex/c-c3.svg"),
    c2: require("../../img/cribisIndex/c-c2.svg"),
    c1: require("../../img/cribisIndex/c-c1.svg"),
    b2: require("../../img/cribisIndex/c-b2.svg"),
    b1: require("../../img/cribisIndex/c-b1.svg"),
    a2: require("../../img/cribisIndex/c-a2.svg"),
    a1: require("../../img/cribisIndex/c-a1.svg"),
};


export const Semaphore = ({ type, readonly = false, size = "large" }) => <div className={`semaphore ${size}`}><img src={getImg(checkType(type), readonly)} alt="semaphore" /></div>

const getImg = (type, readonly) => {
    if (type === "plus" && !readonly) { return green; }
    if (type === "plus" && readonly) { return greenRo; }
    if (type === "stop" && !readonly) { return yellow; }
    if (type === "stop" && readonly) { return yellowRo; }
    if (type === "minus" && !readonly) { return red; }
    if (type === "minus" && readonly) { return redRo; }
    if (type === "") { return yellowRo; }

}

export const SemaphoreGroup = ({ value, size = "large", className = '' }) => {
    return (
        <div className={`sem-group ${size} ${className}`}>
            <Semaphore type={1} readonly={value !== 1} size={size} ></Semaphore>
            <Semaphore type={2} readonly={value !== 2} size={size} ></Semaphore>
            <Semaphore type={3} readonly={value !== 3} size={size} ></Semaphore>
        </div>

    )
}

export const IndexLabel = ({ code, height = '1.5em', padding = '' }) => <img style={{ height: height, width: height, display:'flex', padding: padding }} src={images[code]} alt=""></img>


const checkType = (value) => {
    if (typeof (value) === "number") {
        switch (value) {
            case 1:
                return "plus";
            case 2:
                return "stop";
            case 3:
                return "minus";
            default:
                return "";
        }
    }
    return value;
}

Semaphore.propTypes = {
    type: PropTypes.oneOf(["plus", "stop", "minus", 1, 2, 3]),
    size: PropTypes.oneOf(["small", "medium", "large"])
}
SemaphoreGroup.propTypes = {
    type: PropTypes.oneOf([1, 2, 3]),
    size: PropTypes.oneOf(["small", "medium", "large"])
}
